module.exports = __webpack_public_path__ + "static/media/email.660d87d2.svg";